var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoRicoBrunnerAgPos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 176.25 32.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0.01 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 176.23,
    height: 32.81
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_rico-brunner-ag-pos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_weiss_RGB",
    "data-name": "Logo weiss RGB"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46,18H43.48v5H41.9V10.38H47a3.69,3.69,0,0,1,4,3.36,3.57,3.57,0,0,1,0,.46,3.49,3.49,0,0,1-3.29,3.69l3.42,5.18H49.24Zm.8-6.24H43.48v4.85h3.33a2.43,2.43,0,1,0,.31-4.85h-.31",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 53.66,
    y: 10.38,
    width: 1.58,
    height: 12.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.88,16.73A6.33,6.33,0,0,1,64,10.17h.37a5.68,5.68,0,0,1,4.87,2.51l-1.33.74a4.31,4.31,0,0,0-3.54-1.84,4.87,4.87,0,0,0-4.84,4.88,2.44,2.44,0,0,0,0,.27,4.87,4.87,0,0,0,4.57,5.15h.26A4.26,4.26,0,0,0,67.88,20l1.35.74a5.75,5.75,0,0,1-4.89,2.51,6.32,6.32,0,0,1-6.46-6.19c0-.13,0-.25,0-.37",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.22,10.17a6.2,6.2,0,0,1,6.31,6.09c0,.16,0,.31,0,.47a6.19,6.19,0,0,1-5.81,6.55h-.49c-3.76,0-6.29-2.81-6.29-6.56s2.53-6.56,6.29-6.56m0,1.41c-2.85,0-4.66,2.18-4.66,5.15s1.81,5.16,4.66,5.16,4.66-2.21,4.66-5.16-1.82-5.15-4.66-5.15",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91.28,10.38h5.65c2.21,0,3.56,1.33,3.56,3.23a2.88,2.88,0,0,1-2.23,2.91,3.18,3.18,0,0,1,2.47,3.12,3.33,3.33,0,0,1-3.67,3.43H91.28Zm5.38,5.5a2,2,0,0,0,2.18-1.8,1.34,1.34,0,0,0,0-.2,2,2,0,0,0-1.94-2.06h-4v4.09Zm.08,5.78a2.1,2.1,0,0,0,2.35-1.82,2.29,2.29,0,0,0,0-.37A2.16,2.16,0,0,0,97,17.27H92.86v4.38Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.55,18H105v5h-1.58V10.38h5.09a3.69,3.69,0,0,1,4,3.36,3.57,3.57,0,0,1,0,.46,3.49,3.49,0,0,1-3.29,3.69l3.42,5.18h-1.86Zm.79-6.24H105v4.85h3.32a2.43,2.43,0,1,0,.31-4.85h-.31",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.19,10.38h1.58V18.1c0,2.32,1.26,3.79,3.6,3.79S124,20.42,124,18.1V10.38h1.58v7.74c0,3.16-1.73,5.17-5.17,5.17s-5.18-2-5.18-5.15Z",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "130.29 12.83 130.29 23.07 128.71 23.07 128.71 10.38 130.32 10.38 137.63 20.4 137.63 10.38 139.21 10.38 139.21 23.07 137.69 23.07 130.29 12.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "143.95 12.83 143.95 23.07 142.37 23.07 142.37 10.38 143.98 10.38 151.29 20.4 151.29 10.38 152.87 10.38 152.87 23.07 151.35 23.07 143.95 12.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "156.02 10.38 164.34 10.38 164.34 11.79 157.6 11.79 157.6 15.88 164.2 15.88 164.2 17.28 157.6 17.28 157.6 21.66 164.34 21.66 164.34 23.07 156.02 23.07 156.02 10.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171.14,18h-2.53v5H167V10.38h5.1a3.69,3.69,0,0,1,4,3.36,3.57,3.57,0,0,1,0,.46,3.49,3.49,0,0,1-3.29,3.69l3.43,5.18h-1.87Zm.8-6.24h-3.33v4.85h3.33a2.43,2.43,0,1,0,.31-4.85h-.31",
    transform: "translate(0.01 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.41,0a16.41,16.41,0,1,0,16.4,16.42h0A16.41,16.41,0,0,0,16.41,0m-3.9,23.15L9.3,18H6.77V16.17h3.4a2.37,2.37,0,0,0,.31-4.73H6.77V9.67h3.66a4,4,0,0,1,4.31,3.66,3.85,3.85,0,0,1,0,.48,3.75,3.75,0,0,1-3.35,3.94l3.45,5.4Zm9.62,0H17.65V21.37h4A2,2,0,0,0,24,19.76a2.19,2.19,0,0,0,0-.51,2.06,2.06,0,0,0-2-2.1H17.73V15.39h3.93a2,2,0,0,0,0-4h-4V9.67H22c2.41,0,3.81,1.47,3.81,3.43a3,3,0,0,1-2.35,3.09A3.33,3.33,0,0,1,26,19.51c0,2.12-1.42,3.64-3.91,3.64",
    transform: "translate(0.01 0)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRicoBrunnerAgPos);
export default __webpack_public_path__ + "static/media/logo_rico-brunner-ag-pos.069fd8da.svg";
export { ForwardRef as ReactComponent };